import { ThemeUICSSObject } from 'theme-ui';
import pagination from './pagination';
import { accordion } from './accordion';
import { chat } from './chat';
import { toolbar } from './toolbar';
import autocomplete from './autocomplete';
import { datePicker } from './datePicker';
import { aiMessage } from './aiMessage';
import { infoButton } from './infoButton';
import filters from './filters';
import fileCard from './fileCard';
import scheduler from './scheduler';
import uploader from './uploader';
import { switchCard } from './switchCard';
import { switchBase } from './switchBase';
import freeDayCard from './freeDayCard';
import { bpmGraphViewer } from './bpmGraphViewer';
import { fieldLabel } from './fieldLabel';

/* IMPORT HERE */
export const components: ThemeUICSSObject = {
  /* PREPEND HERE */
  accordion,
  autocomplete,
  bpmGraphViewer,
  fieldLabel,
  datePicker,
  pagination,
  chat,
  scheduler,
  toolbar,
  aiMessage,
  infoButton,
  filters,
  fileCard,
  freeDayCard,
  uploader,
  switchCard,
  switchBase,
};
